<template>
    <div>
        <BasicCard v-if="loading" v-bind:title="'Caricamento in corso'" class="pr-2">
            <v-card-text text-center>
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </v-card-text>
        </BasicCard>

        <div v-else>
            <div v-if="edit">
                <v-form v-model="validityConfig" ref="validityConfig">
                    <BasicCard class="pa-2" title="modifica della configurazione">
                        <template v-slot:action>
                            <v-icon @click.stop="cancel">close</v-icon>
                        </template>
                        <div class="pa-2">
                        <div class="text-h5">Ente emettitore</div>
                        <v-container>
                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex align-center row">
                                    Scelta ente emettitore documenti:
                                    <v-autocomplete dense outlined
                                        hide-details
                                        class="pl-2"
                                        v-model="config.default_org"
                                        :items="orgs"
                                        item-value="id"
                                        item-text="value.name"
                                        :rules="[rules.mandatory]"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                        <div class="text-h5">Soglie per scadenza</div>
                        <v-container>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    Specificare le soglie per il segnale di allerta (<StatusIcon status="warning" class="px-1" />) 
                                    e di allarme (<StatusIcon status="alert" class="px-1" />) per le scadenze degli strumenti:
                                    è possibile definire il numero di giorni o di mesi.
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="pt-4">
                                <v-col cols="6">
                                    <v-autocomplete dense outlined
                                        :items="duration_type"
                                        v-model="config.threshold.type"
                                        item-value="id"
                                        item-text="text"
                                        label="tipo soglia"
                                        :rules="[rules.mandatory]">
                                        </v-autocomplete>
                                </v-col>
                                <v-col cols="3" class="pl-2"> 
                                    <NumericField dense outlined
                                        label="avvertimento"
                                        v-model="config.threshold.warning"
                                        :precision="0"
                                        :negative="true"
                                        :rules="[rules.mandatory]"
                                    />
                                </v-col>
                                <v-col cols="3" class="pl-2">
                                    <NumericField dense outlined
                                        label="allarme"
                                        v-model="config.threshold.alert"
                                        :precision="0"
                                        :negative="true"
                                        :rules="[rules.mandatory]"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                        <div class="text-h5">Calcolo scadenze</div>
                        <v-container>
                            <v-row no-gutters>
                                <v-col cols="12" class="pb-2">
                                    Specificare per ogni tipologia di report come calcolare la scadenza: 
                                    fine del mese oppure scadenza al giorno esatto.
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="pt-2">
                                    <span class="text-uppercase font-italic text-subtitle-2">Verificazione periodica:</span>
                                    <v-radio-group dense outlined
                                        class="my-0"
                                        v-model="config.deadline.leg" row>
                                        <v-radio label="scadenza esatta" value="expire"></v-radio>
                                        <v-radio label="fine mese" value="end_of_month"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <span class="pt-2 text-uppercase font-italic text-subtitle-2">Taratura scientifica:</span>
                                    <v-radio-group dense outlined
                                        class="my-0"
                                        v-model="config.deadline.iso" row>
                                        <v-radio label="scadenza esatta" value="expire"></v-radio>
                                        <v-radio label="fine mese" value="end_of_month"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <span class="pt-2 text-uppercase font-italic text-subtitle-2">Taratura scientifica semplificata:</span>
                                    <v-radio-group dense outlined
                                        class="my-0"
                                        v-model="config.deadline.iso_simple" row>
                                        <v-radio label="scadenza esatta" value="expire"></v-radio>
                                        <v-radio label="fine mese" value="end_of_month"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <!--v-row no-gutters>
                                <v-col cols="12">
                                    <span>Certificazione LAT:</span>
                                    <v-radio-group v-model="config.deadline.lat" row>
                                        <v-radio label="scadenza esatta" value="expire"></v-radio>
                                        <v-radio label="fine mese" value="end_of_month"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row-->
                        </v-container>
                        <div class="text-h5">Generazione codice report</div>
                        <v-container>
                            <v-row no-gutters>
                                <v-col cols="12" class="pt-2">
                                    <span class="pt-2 text-uppercase font-italic text-subtitle-2">Numerazione report</span>
                                    <v-radio-group dense outlined
                                        class="my-0"
                                        v-model="config.enable_report_code_gen" row>
                                        <v-radio label="generazione automatica" :value="true"></v-radio>
                                        <v-radio label="assegnazione manuale" :value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row no-gutters v-if="config.enable_report_code_gen">
                                <v-col cols="6">
                                    <v-text-field dense outlined
                                        disabled
                                        label="anno"
                                        v-model="config.report_year"
                                        type="number"
                                        :rules="[rules.mandatory]"
                                    />
                                </v-col>

                                <v-col cols="6"><span class="font-italic pl-2 text-uppercase">-CODICE UTENTE-n° progressivo</span>
                                </v-col>
                            </v-row>
                        </v-container>
                        <div class="text-h5">Lettura QRCode</div>
                        <!--div class="text-h6 d-flex flex-row align-center">Cifratura (AES 256bit CDC PKCS7):
                           <v-switch
                                class="pl-4"
                                v-model="config.qrcode.enable_crypt"
                                inset
                                :label="config.qrcode.enable_crypt ? `abilitata` : `disabilitata`"
                            ></v-switch>
                        </div-->
                        <div class="text-h6">URL ammesse</div>
                        <v-container>
                            <v-row no-gutters>
                                <v-col class="d-flex flex-row" cols="12">
                                    <ul>
                                        <li v-for="(prefix, idx) of config.qrcode.prefixes" :key="idx">
                                            <span class="d-flex font-italic">{{prefix}}<v-icon class="pl-4" @click="removePrefix(idx)">close</v-icon></span>
                                        </li>
                                    </ul>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-text-field dense outlined
                                    label="prefisso url del qrcode"
                                    v-model="new_qr_url"
                                />
                                <v-btn color="action" class="ml-2" :disabled="!this.new_qr_url.trim()" @click.stop="addPrefix">salva URL</v-btn>
                            </v-row>
                        </v-container>
                        </div>
                    </BasicCard>
                </v-form>
                <div v-can="{obj_type:'config', action: 'edit'}" class="d-flex flex-column justify-center my-4">
                    <v-alert class="d-flex" v-if="errorMessage" type="warning">
                        {{errorMessage}} 
                    </v-alert>
                    <div class="d-flex align-center justify-center my-4">
                    <v-btn color="primary" :disabled="$store.state.offline || !validityConfig" @click="saveConfig">Salva</v-btn>
                    <v-btn class="ml-2" text @click="cancel">Annulla</v-btn>
                    </div>
                </div>
            </div>
            <div v-else>
                <BasicCard class="pa-2" title="configurazione attuale">
                    <template v-slot:action>
                        <v-btn v-can="{obj_type:'config', action: 'edit'}" color="action" fab small @click.stop="editConfig"><v-icon>edit</v-icon></v-btn>
                    </template>
                    <div class="pa-2">
                        <div class="text-h5 pt-2">Ente emittore:
                            <span v-if="org_sel">
                            <span class="font-weight-bold">{{org_sel.value.name}}</span> - P.IVA: <span class="font-weight-bold">{{ org_sel.value.piva}}</span>
                            </span>
                            <span v-else>-</span>

                        </div>
                    </div>
                    <v-divider />
                    <div class="pa-2">
                        <div class="text-h5 pt-2">Soglie per scadenza strumenti</div>
                        <v-container class="pa-0 pl-2">
                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex align-center text-subtitle-1">
                                    <StatusIcon status="alert" class="pr-2" />{{ o_config.threshold.alert }} {{ duration_type_d[o_config.threshold.type].text}}
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex align-center text-subtitle-1">
                                    <StatusIcon status="warning" class="pr-2"/>{{ o_config.threshold.warning }} {{ duration_type_d[o_config.threshold.type].text }}
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="d-flex align-center text-subtitle-1">
                                    <StatusIcon status="ready" class="pr-2"/>antecendente {{ o_config.threshold.warning }} {{ duration_type_d[o_config.threshold.type].text }}
                                </v-col>
                            </v-row>
                        </v-container>
                        <div class="text-h5 pt-2">Calcolo scadenze</div>
                        <v-container class="pa-0 pl-2">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <span class="text-uppercase font-italic text-subtitle-2 pt-1 pr-2">Verificazione periodica:</span> <b>{{ deadline_type[o_config.deadline.leg]}}</b>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <span class="pt-1 text-uppercase font-italic text-subtitle-2 pr-2">Taratura scientifica:</span> <b>{{ deadline_type[o_config.deadline.iso]}}</b>
                                    
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <span class="pt-1 text-uppercase font-italic text-subtitle-2 pr-2">Taratura scientifica semplificata:</span> <b>{{ deadline_type[o_config.deadline.iso_simple]}}</b>
                                </v-col>
                            </v-row>
                            <!--v-row no-gutters>
                                <v-col cols="12">
                                    <span class="pt-2 text-uppercase font-italic text-subtitle-2">Certificatione LAT:</span>  {{ deadline_type[config.deadline.lat]}}
                                </v-col>
                            </v-row-->
                        </v-container>
                        <div class="text-h5 pt-2">Generazione codice report:
                            <span class="pl-2" v-if="config.enable_report_code_gen">automatica</span>
                            <span class="pl-2" v-else>manuale</span>
                        </div>
                        <v-container class="pa-0 pl-2">
                            <v-row v-if="config.enable_report_code_gen" no-gutters>
                                <v-col class="d-flex flex-row" cols="12">
                                    <span class="d-flex text-uppercase font-italic text-subtitle-2">formato codice report:</span>
                                    <span class="d-flex pl-3">{{ config.report_year }}- <i>&lt;CODICE UTENTE&gt;</i> - <i>&lt;tipo report&gt;</i> - <i>&lt;n° progressivo&gt;</i></span>
                                </v-col>
                            </v-row>
                        </v-container>
                        <div class="text-h5 pt-2">Lettura QRCode</div>
                        <!--div class="text-uppercase font-italic text-subtitle-2 pt-1 pl-2">Cifratura (AES 256bit CDC PKCS7):
                            <span class="pl-2 " v-if="config.qrcode.enable_crypt">abilitata</span>
                            <span class="pl-2" v-else>disabilitata</span>
                        </div-->
                        <div v-if="config.qrcode.prefixes.length > 0">
                            <div class="text-uppercase font-italic text-subtitle-2 pt-1 pl-2">URL ammesse:</div>
                                <v-container class="pa-0 pl-2">
                                    <v-row no-gutters>
                                        <v-col class="d-flex flex-row" cols="12">
                                            <ul>
                                                <li v-for="(prefix, idx) in config.qrcode.prefixes" :key="idx">                                
                                                    <span class="d-flex font-italic">{{prefix}}</span>
                                                </li>
                                            </ul>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </div>
                        </div>
                </BasicCard>
            </div>
        </div>
    </div>
</template>
<script>
// import _ from 'lodash'
import {getModel} from "../../utils/model"
import StatusIcon from '../../components/utils/StatusIcon'
import {searchDesign, orderByFields} from "../../utils/dbUtility"
import {f_rules} from "../../utils/commonUtils"
import BasicCard from '../../components/utils/Basic_card'
export default {
    props: {
        
    },
    components: {
        BasicCard, StatusIcon
    },
    data() {
        return {
            validityConfig: true,
            loading: true,
            rules: f_rules,
            duration_type: [
                {id: 'month', text: 'mesi'},
                {id: 'day', text: 'giorni'}
            ],
            deadline_type: {
                'end_of_month': 'fine mese',
                'expire': 'scadenza reale',
            },
            config: {},
            edit: false,
            o_config: null,
            orgs: [],
            errorMessage: null,
            new_qr_url: ''
        }
    },
    async mounted(){
        this.loading = true
        this.o_config = await this.$store.state.$pouch.get('system', "config:data")
        console.log("config", this.o_config)
        if (this.o_config != null) {
            this.config = _.cloneDeep(this.o_config)
        }
        this.duration_type_d = _.keyBy(this.duration_type, 'id')
        let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', "organism", false)
        this.orgs = orderByFields(res, {value: ['value.name'], order: ['asc']})   
        this.loading = false
        this.errorMessage = null
        // this.$refs.categoryRegistry.resetValidation()
    },
    methods: {
        async saveConfig() {
            this.errorMessage = null
            this.config.updated = (new Date()).getTime()
            this.config.updated_by = this.$store.state.user._id
            let config = {...this.config}
            config.threshold.warning = parseInt(config.threshold.warning)
            config.threshold.alert = parseInt(config.threshold.alert)
            let SystemConfig = getModel('SystemConfig')
            let config_copy = SystemConfig(config)
            let res = await this.axios.put('mastercal/system/saveConfig/'+config._id, config_copy).catch(error => {
                console.log("error status", error);
                this.errorMessage = "errore di connessione al server - riprovare. Se il problema persiste contattare l'amministratore"
            });
            if (res && res.data) {
                this.o_config = _.cloneDeep(res.data)
                this.o_config._rev = res.rev
                this.closeEdit()
            }
        
        },
        editConfig() {
            this.edit = true
        },
        closeEdit() {
            this.edit = false
        },
        cancel() {
            this.config = _.cloneDeep(this.o_config)
            this.closeEdit()
        },
        addPrefix() {
            if (this.new_qr_url.trim()) {
                this.config.qrcode.prefixes.push(this.new_qr_url)
                this.new_qr_url = ''
            }
        },
        removePrefix(idx) {
            this.config.qrcode.prefixes.splice(idx, 1)
        }
    },
    computed: {
        org_sel() {
            if (!this.o_config || !this.o_config.default_org) {
                return null
            }
            let org = _.find(this.orgs, { 'id': this.o_config.default_org });
            return org
        }
    }
}
</script>